import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
} from "reactstrap";
import {
  createOwnAssetsMovementGuides,
  getAllDocumentList,
  getCustomerAddressList,
  getDeliveryMethodList,
  getDocumentSetList,
  getListCountry,
  getListCurrency,
  getListCustomerList,
  getListMainproduct,
  getMoloniVehiclesList,
  getTaxList,
  viewOwnAssetsMovementGuides,
  updateOwnAssetsMovementGuides,
  createListCustomer,
  getMaturityDatesList,
  getListSalesmenList,
} from "../../services/MoloniServices";
import Select from "react-select";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getCommonSearchList } from "../../services/settingsServices";


const AddOwnAssetsMovement = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);
  const initialTax = { tax_id: 0, value: 0, order: 0, cumulative: 0 };
  const initialChildProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const initialProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    order: 0,
    exemption_reason: "",
    taxes: [initialTax],
  };

  const [ownAssetsMgData, setownAssetsMgData] = useState({
    id: "",
    moloni_id: "",
    date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    alternate_address_id: "",
    your_reference: "",
    products: [initialProduct],
    exchange_currency_id: "",
    exchange_rate: "",
    delivery_method_id: "",
    delivery_datetime: "",
    delivery_departure_address: "",
    delivery_departure_city: "",
    delivery_departure_zip_code: "",
    delivery_departure_country: "",
    delivery_destination_address: "",
    delivery_destination_city: "",
    delivery_destination_zip_code: "",
    delivery_destination_country: "",
    vehicle_id: "",
    vehicle_name: "",
    vehicle_number_plate: "",
    notes: "",
    status: 0,
    expiration_date: "",
    customer_iva: 0,
    alternate_address: [],
    actual_date_check: 0,
    save_my_vehicle: 0,
    preset: 0,
    company_check: 0,
    customer_check: 0,
    alternate_address: [],
    order_id: "",
    customer_reference: "",
  });

  let errorsObj = {
    date: "",
    document_set_id: "",
    customer_id: "",
    expiration_date: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [customerList, seCustomerList] = useState([]);
  const [vehiclesList, setVehiclesList] = useState([]);
  const [AssetsMovementGuidesData, setAssetsMovementGuidesgData] = useState("");
  const [exchangeCurrList, setExchangeCurrList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);
  const [assocDataList, setAssocDataList] = useState([]);
  const [errorsPro, setErrorsPro] = useState({});
  const [selectedProduct, setSelectedProduct] = useState("");
  const [alternateAddressList, setAlternateAddressList] = useState([]);
  const [deliveryMethodList, setDeliveryMethodList] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [customerModel, setCustomerModel] = useState(false);
  const [activeCustomerTab, setActiveCustomerTab] = useState("1");
  const [languageList, setLanguageList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [maturityDatesList, setMaturityDatesList] = useState([]);
  const [priceClassList, setPriceClassList] = useState([]);
  const [salesmenList, setSalesmenDatesList] = useState([]);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [openFinancial, setOpenFinancial] = useState(false);
  const [openNotes, setOpenNotes] = useState(false);
  const [openDelivery, setOpenDelivery] = useState(false);
  const [showCreateVehicle, setShowCreateVehicle] = useState(false);
  const [altForm, setAltForm] = useState({
    description: "",
    code: "",
    address: "",
    zip_code: "",
    city: "",
    country: "",
    email: "",
    phone: "",
    fax: "",
    contact_person: "",
  });

  const [editIndex, setEditIndex] = useState(null);

  const [customerData, setCustomerData] = useState({
    id: "",
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
    moloni_id: "",
    contact_person: "",
    contact_notes: "",
    customer_iva: 0,
    series_id: "",
    price_id: "",
  });
  const [filterList, seFilterList] = useState([]);
  const [salesMenDataList, setSalesMenDataList] = useState([]);

  const [exemptionList, setExemptionList] = useState([]);
  
  
  
    useEffect(function () {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        type: "exception_list",
      };
      getCommonSearchList(data)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].code,
              label: response.data[i].description,
            });
          }
  
          setExemptionList(list);
        })
        .catch((err) => {});
    }, []);

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleSelectCustomer = (item) => {
    setSearch(item.name);
    setSelectedCustomerId(item.moloni_id);
  };

  const handleShippingDelete = () => {
    setownAssetsMgData({
      ...ownAssetsMgData,
      delivery_method_id: "",
      delivery_departure_address: "",
      delivery_departure_city: "",
      delivery_departure_zip_code: "",
      delivery_departure_country: "",
      delivery_destination_address: "",
      delivery_destination_city: "",
      delivery_destination_zip_code: "",
      delivery_destination_country: "",
      actual_date_check: 0,
      save_my_vehicle: 0,
      preset: 0,
      company_check: 0,
      customer_check: 0,
    });
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    return now.toISOString().slice(0, 16);
  };

  const handleAltChange = (e) => {
    setAltForm({
      ...altForm,
      [e.target.name]: e.target.value,
    });
  };

  const resetAltForm = () => {
    setAltForm({
      description: "",
      code: "",
      address: "",
      zip_code: "",
      city: "",
      country: "",
      email: "",
      phone: "",
      fax: "",
      contact_person: "",
    });
    setEditIndex(null);
  };

  const editAlternateAddress = (index) => {
    setAltForm(ownAssetsMgData.alternate_address[index]);
    setEditIndex(index);
  };

  const deleteAlternateAddress = (index) => {
    const updated = ownAssetsMgData.alternate_address.filter(
      (_, i) => i !== index,
    );

    setownAssetsMgData({
      ...ownAssetsMgData,
      alternate_address: updated,
    });
  };

  const saveAlternateAddress = () => {
    if (
      !altForm.description ||
      !altForm.code ||
      !altForm.address ||
      !altForm.zip_code ||
      !altForm.city ||
      !altForm.country
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    let updatedList = [...ownAssetsMgData.alternate_address];

    if (editIndex !== null) {
      updatedList[editIndex] = altForm;
    } else {
      updatedList.push(altForm);
    }

    setownAssetsMgData({
      ...ownAssetsMgData,
      alternate_address: updatedList,
    });

    resetAltForm();
  };

  const handleCustomerCloseModel = () => {
    setCustomerModel(false);
  };

  const validateProduct = (product, index) => {
    let newErrors = {};

    if (!product.product_id) newErrors.product_id = "Product is required";
    if (!product.name?.trim()) newErrors.name = "Name is required";
    if (!product.qty || product.qty <= 0)
      newErrors.qty = "Quantity is required";
    if (!product.price || product.price <= 0)
      newErrors.price = "Price is required";

    setErrorsPro((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };

  const handleAddProduct = (e) => {
    e.preventDefault();

    let list = [...ownAssetsMgData.products];
    list.push({ ...initialProduct });

    setownAssetsMgData({
      ...ownAssetsMgData,
      products: list,
    });
  };

  const handleRemoveProduct = (e, index) => {
    e.preventDefault();

    let list = [...ownAssetsMgData.products];
    list.splice(index, 1);

    setownAssetsMgData({
      ...ownAssetsMgData,
      products: list,
    });
  };

  const handleAddChildProduct = (e, productIndex) => {
    e.preventDefault();
    let list = [...ownAssetsMgData.products];
    if (!list[productIndex].child_products) {
      list[productIndex].child_products = [];
    }
    list[productIndex].child_products.push({ ...initialChildProduct });
    setownAssetsMgData({ ...ownAssetsMgData, products: list });
  };

  const handleRemoveChildProduct = (e, productIndex, childIndex) => {
    e.preventDefault();
    let list = [...ownAssetsMgData.products];
    list[productIndex].child_products.splice(childIndex, 1);
    setownAssetsMgData({ ...ownAssetsMgData, products: list });
  };

  const handleAddChildProperty = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...ownAssetsMgData.products];

    if (!list[productIndex].child_products[childIndex].properties) {
      list[productIndex].child_products[childIndex].properties = [];
    }

    list[productIndex].child_products[childIndex].properties.push({
      title: "",
      value: "",
    });

    setownAssetsMgData({
      ...ownAssetsMgData,
      products: list,
    });
  };

  const handleAddChildTax = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...ownAssetsMgData.products];

    if (!list[productIndex].child_products[childIndex].taxes) {
      list[productIndex].child_products[childIndex].taxes = [];
    }

    list[productIndex].child_products[childIndex].taxes.push({
      tax_id: null,
      value: 0,
      order: null,
      cumulative: 0,
    });

    setownAssetsMgData({
      ...ownAssetsMgData,
      products: list,
    });
  };

  const handleAddTax = (e, productIndex) => {
    e.preventDefault();

    let list = [...ownAssetsMgData.products];
    list[productIndex].taxes.push({ ...initialTax });

    setownAssetsMgData({
      ...ownAssetsMgData,
      products: list,
    });
  };

  const handleRemoveTax = (e, productIndex, taxIndex) => {
    e.preventDefault();

    let list = [...ownAssetsMgData.products];
    list[productIndex].taxes.splice(taxIndex, 1);

    setownAssetsMgData({
      ...ownAssetsMgData,
      products: list,
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSalesmenList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSalesmenDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeliveryMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeliveryMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (uuid) {
      let data = { id: uuid };
      viewOwnAssetsMovementGuides(data)
        .then((response) => {
          setAssetsMovementGuidesgData(response.data.data);
        })
        .catch((err) => {
          navigate("/ownAssetsMovement");
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(() => {
    if (AssetsMovementGuidesData) {
      setownAssetsMgData({
        id: AssetsMovementGuidesData?.id,
        date: AssetsMovementGuidesData?.date,
        document_set_id: AssetsMovementGuidesData?.document_set_id,
        customer_id: AssetsMovementGuidesData?.customer_id,
        alternate_address_id: AssetsMovementGuidesData?.alternate_address_id,
        your_reference: AssetsMovementGuidesData?.your_reference,
        associated_documents: AssetsMovementGuidesData?.associated_documents,
        products: AssetsMovementGuidesData?.products,
        exchange_currency_id: AssetsMovementGuidesData?.exchange_currency_id,
        exchange_rate: AssetsMovementGuidesData?.exchange_rate,
        delivery_method_id: AssetsMovementGuidesData?.delivery_method_id,
        delivery_datetime: AssetsMovementGuidesData?.delivery_datetime,
        delivery_departure_city:
          AssetsMovementGuidesData?.delivery_departure_city,
        delivery_departure_zip_code:
          AssetsMovementGuidesData?.delivery_departure_zip_code,
        delivery_departure_country:
          AssetsMovementGuidesData?.delivery_departure_country,
        delivery_destination_address:
          AssetsMovementGuidesData?.delivery_destination_address,
        delivery_destination_city:
          AssetsMovementGuidesData?.delivery_destination_city,
        delivery_destination_zip_code:
          AssetsMovementGuidesData?.delivery_destination_zip_code,
        delivery_destination_country:
          AssetsMovementGuidesData?.delivery_destination_country,
        vehicle_id: String(AssetsMovementGuidesData?.vehicle_id),
        vehicle_name: AssetsMovementGuidesData?.vehicle_name,
        vehicle_number_plate: AssetsMovementGuidesData?.vehicle_number_plate,
        notes: AssetsMovementGuidesData?.notes,
        status: AssetsMovementGuidesData?.status,
        delivery_departure_address:
          AssetsMovementGuidesData?.delivery_departure_address,
        expiration_date: AssetsMovementGuidesData?.expiration_date,
        order_id: AssetsMovementGuidesData?.order_id,
        customer_reference: AssetsMovementGuidesData?.customer_reference,
      });
      setSelectedCustomerId(AssetsMovementGuidesData?.customer_id);
    }
  }, [AssetsMovementGuidesData]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getAllDocumentList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].entity_name,
            net_value: response?.data[i].net_value,
          });
        }

        setAssocDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListMainproduct(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
            price: response.data[i].price,
            stock: response.data[i].stock,
            exemption_reason: response.data[i].exemption_reason,
            taxes: response.data[i].taxes,
            properties: response.data[i].properties,
            warehouse: response.data[i].warehouse,
          });
        }

        setProductList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      const initialProduct = {
        product_id: selectedProduct?.value,
        name: selectedProduct.label || "",
        summary: "",
        qty: selectedProduct.stock || 0,
        price: selectedProduct.price || 0,
        discount: 0,
        deduction_id: "",
        order: 0,
        exemption_reason: "",
        warehouse_id: selectedProduct.warehouse,
        properties: selectedProduct.properties || [],
        taxes: selectedProduct.taxes || [],
      };

      setownAssetsMgData((prev) => ({
        ...prev,
        products: [initialProduct],
      }));
    }
  }, [selectedProduct]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(
    function () {
      if (selectedCustomerId) {
        let data = {
          limit: 20,
          page: 1,
          search: "",
          customer_id: selectedCustomerId,
        };
        getCustomerAddressList(data)
          .then((res) => {
            const response = res.data.address;

            let list = [];
            for (let i = 0; i < response.length; i++) {
              list.push({
                value: response[i].moloni_id,
                label: response[i].name,
              });
            }

            setAlternateAddressList(list);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          });
      }
    },
    [selectedCustomerId],
  );

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCountryList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCurrency(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setExchangeCurrList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);
  useEffect(
    function () {
      let data = {
        limit: 20,
        page: 1,
        search: search ? search : "",
      };
      getListCustomerList(data)
        .then((response) => {
          seCustomerList(response.data.data);
          if (search) {
            seFilterList(response.data.data);
          }
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    },
    [search],
  );
  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMoloniVehiclesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].description,
          });
        }

        setVehiclesList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;
    let errorObj = { ...errorsObj };

    if (!ownAssetsMgData.document_set_id) {
      errorObj.document_set_id = `Document Set is required.`;
      error = true;
      setBtnLoader(false);
    }

    // if (!ownAssetsMgData.customer_id) {
    //   errorObj.customer_id = `Customer is required.`;
    //   error = true;
    //   setBtnLoader(false);
    // }

    if (!ownAssetsMgData.delivery_departure_address) {
      errorObj.delivery_departure_address = `Delivery departure address is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!ownAssetsMgData.delivery_departure_city) {
      errorObj.delivery_departure_city = `Delivery departure city is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!ownAssetsMgData.delivery_departure_zip_code) {
      errorObj.delivery_departure_zip_code = `Delivery departure zip code is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!ownAssetsMgData.delivery_departure_country) {
      errorObj.delivery_departure_country = `Delivery departure country is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!ownAssetsMgData.delivery_destination_address) {
      errorObj.delivery_destination_address = `Delivery destination address is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!ownAssetsMgData.delivery_destination_city) {
      errorObj.delivery_destination_city = `Delivery destination city is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!ownAssetsMgData.delivery_destination_zip_code) {
      errorObj.delivery_destination_zip_code = `Delivery destination zipCode is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!ownAssetsMgData.delivery_destination_zip_code) {
      errorObj.delivery_destination_zip_code = `Delivery destination zipCode is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!ownAssetsMgData.delivery_destination_country) {
      errorObj.delivery_destination_country = `Delivery destination country is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!ownAssetsMgData.delivery_method_id) {
      errorObj.delivery_method_id = `Delivery method is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!ownAssetsMgData?.delivery_datetime) {
      errorObj.delivery_datetime = `Delivery date is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    let allValid = true;
    ownAssetsMgData?.products?.forEach((product, i) => {
      if (!validateProduct(product, i)) {
        allValid = false;
      }
    });

    if (!allValid) {
      toast.error("Product is Required");
      return;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    let data = {
      date: ownAssetsMgData?.date,
      document_set_id: ownAssetsMgData?.document_set_id,
      customer_id: selectedCustomerId,
      alternate_address_id: ownAssetsMgData?.alternate_address_id,
      your_reference: ownAssetsMgData?.your_reference,
      products: ownAssetsMgData?.products,
      exchange_currency_id: ownAssetsMgData?.exchange_currency_id,
      exchange_rate: ownAssetsMgData?.exchange_rate,
      delivery_method_id: ownAssetsMgData?.delivery_method_id,
      delivery_datetime: ownAssetsMgData?.delivery_datetime,
      delivery_departure_city: ownAssetsMgData?.delivery_departure_city,
      delivery_departure_zip_code: ownAssetsMgData?.delivery_departure_zip_code,
      delivery_departure_country: ownAssetsMgData?.delivery_departure_country,
      delivery_destination_address:
        ownAssetsMgData?.delivery_destination_address,
      delivery_destination_city: ownAssetsMgData?.delivery_destination_city,
      delivery_destination_zip_code:
        ownAssetsMgData?.delivery_destination_zip_code,
      delivery_destination_country:
        ownAssetsMgData?.delivery_destination_country,
      vehicle_id: ownAssetsMgData?.vehicle_id,
      vehicle_name: ownAssetsMgData?.vehicle_name,
      vehicle_number_plate: ownAssetsMgData?.vehicle_number_plate,
      notes: ownAssetsMgData?.notes,
      status: ownAssetsMgData?.status,
      delivery_departure_address: ownAssetsMgData?.delivery_departure_address,
      expiration_date: ownAssetsMgData?.expiration_date,
      order_id: ownAssetsMgData?.order_id,
      customer_reference: ownAssetsMgData?.customer_reference,
    };

    let updateData = {
      id: ownAssetsMgData?.id,
      document_id: AssetsMovementGuidesData?.document_id,
      date: ownAssetsMgData?.date,
      document_set_id: ownAssetsMgData?.document_set_id,
      customer_id: selectedCustomerId,
      alternate_address_id: ownAssetsMgData?.alternate_address_id,
      your_reference: ownAssetsMgData?.your_reference,
      special_discount: ownAssetsMgData?.special_discount,
      products: ownAssetsMgData?.products,
      exchange_currency_id: ownAssetsMgData?.exchange_currency_id,
      exchange_rate: ownAssetsMgData?.exchange_rate,
      delivery_method_id: ownAssetsMgData?.delivery_method_id,
      delivery_datetime: ownAssetsMgData?.delivery_datetime,
      delivery_departure_city: ownAssetsMgData?.delivery_departure_city,
      delivery_departure_zip_code: ownAssetsMgData?.delivery_departure_zip_code,
      delivery_departure_country: ownAssetsMgData?.delivery_departure_country,
      delivery_destination_address:
        ownAssetsMgData?.delivery_destination_address,
      delivery_destination_city: ownAssetsMgData?.delivery_destination_city,
      delivery_destination_zip_code:
        ownAssetsMgData?.delivery_destination_zip_code,
      delivery_destination_country:
        ownAssetsMgData?.delivery_destination_country,
      vehicle_id: ownAssetsMgData?.vehicle_id,
      vehicle_name: ownAssetsMgData?.vehicle_name,
      vehicle_number_plate: ownAssetsMgData?.vehicle_number_plate,
      notes: ownAssetsMgData?.notes,
      status: ownAssetsMgData?.status,
      delivery_departure_address: ownAssetsMgData?.delivery_departure_address,
      expiration_date: ownAssetsMgData?.expiration_date,
      order_id: ownAssetsMgData?.order_id,
      customer_reference: ownAssetsMgData?.customer_reference,
    };

    if (AssetsMovementGuidesData?.id) {
      updateOwnAssetsMovementGuides(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/ownAssetsMovement");
          setownAssetsMgData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createOwnAssetsMovementGuides(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/ownAssetsMovement");
          setownAssetsMgData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  const handleCustomerSubmit = (e) => {
    e.preventDefault();

    if (!customerData.vat) {
      toast.error("Vat is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.number) {
      toast.error("Number is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.name) {
      toast.error("Name is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.language_id) {
      setActiveCustomerTab("4");
      toast.error("Language is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.address) {
      toast.error("Address is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.city) {
      toast.error("City is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.zip_code) {
      toast.error("Zip Code is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.country_id) {
      toast.error("Country is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.email) {
      toast.error("Email is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.phone) {
      toast.error("Phone is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.maturity_date_id) {
      toast.error("Maturity Date is required.");
      setActiveCustomerTab("4");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.payment_method_id) {
      toast.error("Payment Method is required.");
      setActiveCustomerTab("4");
      setIsModifyButtonLoad(false);
      return;
    }

    let data = {
      company_id: "269134",
      vat: customerData?.vat,
      number: customerData?.number,
      name: customerData?.name,
      language_id: customerData?.language_id,
      qty_copies_document: customerData?.qty_copies_document,
      notes: customerData?.notes,
      country_id: customerData?.country_id,
      address: customerData?.address,
      zip_code: customerData?.zip_code,
      city: customerData?.city,
      email: customerData?.email,
      website: customerData?.website,
      phone: customerData?.phone,
      fax: customerData?.fax,
      contact_name: customerData?.contact_name,
      contact_email: customerData?.contact_email,
      contact_phone: customerData?.contact_phone,
      discount: customerData?.discount,
      credit_limit: customerData?.credit_limit,
      payment_method_id: customerData?.payment_method_id,
      delivery_method_id: customerData?.delivery_method_id,
      maturity_date_id: customerData?.maturity_date_id,
      field_notes: customerData?.field_notes,
      salesman_id: customerData?.salesman_id,
      price_class_id: customerData?.price_class_id,
      payment_day: customerData?.payment_day,
      document_type_id: 0,
    };

    createListCustomer(data)
      .then((response) => {
        toast.success(response.data.message);

        setIsModifyButtonLoad(false);
        setCustomerData({
          id: "",
          vat: "",
          number: "",
          name: "",
          language_id: "",
          qty_copies_document: "",
          notes: "",
          country_id: "",
          address: "",
          zip_code: "",
          city: "",
          email: "",
          website: "",
          phone: "",
          fax: "",
          contact_name: "",
          contact_email: "",
          contact_phone: "",
          discount: "",
          credit_limit: "",
          payment_method_id: "",
          delivery_method_id: "",
          maturity_date_id: "",
          field_notes: "",
          salesman_id: "",
          price_class_id: "",
          payment_day: "",
          document_type_id: "",
          moloni_id: "",
        });

        setCustomerModel(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-document")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">{t("ownAssetsMg")}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmit}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("issue_date")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control"
                                  type="date"
                                  value={ownAssetsMgData.date}
                                  onChange={(e) => {
                                    setownAssetsMgData({
                                      ...ownAssetsMgData,
                                      date: e.target.value,
                                    });
                                  }}
                                  name="date"
                                  placeholder="Select Date"
                                />
                              </div>
                              {errors.date && (
                                <span className="input-error">
                                  {errors.date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("documentSet")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={documentSetList}
                                  value={documentSetList.find(
                                    (item) =>
                                      item.value ===
                                      ownAssetsMgData.document_set_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setownAssetsMgData({
                                      ...ownAssetsMgData,
                                      document_set_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document Set"}
                                />
                                {errors.document_set_id && (
                                  <span className="input-error">
                                    {errors.document_set_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3 mt-3">
                          <FormGroup>
                            <Label
                              className="col-form-label ml-2 Label-my form-label form-label"
                              htmlFor="paper_invoice_issuance"
                            ></Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input mt-3"
                                    type="checkbox"
                                    checked={
                                      ownAssetsMgData.paper_invoice_issuance ===
                                      1
                                    }
                                    onChange={(e) => {
                                      setownAssetsMgData({
                                        ...ownAssetsMgData,
                                        paper_invoice_issuance: e.target.checked
                                          ? 1
                                          : 0,
                                      });
                                    }}
                                    id="paper_invoice_issuance"
                                  />
                                  <Label
                                    htmlFor="paper_invoice_issuance"
                                    className="col-form-label ml-2 Label-my form-label form-label mt-1"
                                  >
                                    {t("PaperlessInvoiceIssuance")}
                                  </Label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div>
                          <p>{t("ToIndicateADifferent")}</p>
                        </div>

                        <div className="row">
                          <div
                            className="card"
                            style={{
                              padding: "0px",
                              marginLeft: "15px",
                            }}
                          >
                            <div
                              className="card-header"
                              style={{
                                background: "#81bb42",
                                fontWeight: "600",
                              }}
                            >
                              {t("customers")}
                            </div>
                            <div className="card-body">
                              <div className="row">
                                <div
                                  className="col-md-9 position-relative"
                                  style={{
                                    // marginLeft: "-87px",
                                    padding: "15px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control pe-5"
                                    placeholder="Customers Search"
                                    value={search}
                                    onChange={(e) =>
                                      handleSearch(e.target.value)
                                    }
                                  />
                                  {search && (
                                    <i
                                      className="bi bi-x-circle-fill text-muted"
                                      style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => handleSearch("")}
                                    ></i>
                                  )}
                                </div>

                                <div className="col-md-2 mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => setCustomerModel(true)}
                                  >
                                    {t("createCustomer")}{" "}
                                    <i className="bi bi-check2"></i>
                                  </button>
                                </div>

                                {filterList?.length > 0 && (
                                  <table className="table table-bordered mt-2">
                                    <thead>
                                      <tr>
                                        <th>Code</th>
                                        <th>Name</th>
                                        <th>Address</th>
                                        <th>VAT Number</th>
                                        <th>Product Price Table</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {filterList?.map((item, index) => (
                                        <tr
                                          key={index}
                                          style={{ cursor: "pointer" }}
                                          className={
                                            selectedCustomerId ===
                                            item.moloni_id
                                              ? "table-active"
                                              : ""
                                          }
                                          onClick={() =>
                                            handleSelectCustomer(item)
                                          }
                                        >
                                          <td>{item.moloni_id}</td>
                                          <td>{item.name}</td>
                                          <td>{item.address}</td>
                                          <td>{item.vat}</td>
                                          <td>
                                            {item.price_class_name || "-"}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="section-box mt-3">
                          <div
                            className={`section-header-green ${
                              openFinancial ? "active" : ""
                            }`}
                            onClick={() => setOpenFinancial(!openFinancial)}
                          >
                            <i
                              className={`bi ${
                                openFinancial
                                  ? "bi-chevron-up"
                                  : "bi-chevron-down"
                              }`}
                            ></i>
                            <span className="ms-2">Financial Data</span>
                          </div>
                          <div
                            className={`collapse ${
                              openFinancial ? "show" : ""
                            }`}
                          >
                            <div className="row mt-3">
                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("orderQuote")}
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={ownAssetsMgData.order_id}
                                    onChange={(e) => {
                                      setownAssetsMgData({
                                        ...ownAssetsMgData,
                                        order_id: e.target.value,
                                      });
                                    }}
                                    name="order_id"
                                    placeholder="Order/Quote"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("maturity")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        className="my-select-v"
                                        options={maturityDatesList}
                                        value={maturityDatesList.find(
                                          (item) =>
                                            item.value ==
                                            ownAssetsMgData.maturity_date_id,
                                        )}
                                        onChange={(selectedOption) => {
                                          setownAssetsMgData({
                                            ...customerData,
                                            ownAssetsMgData: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Maturity"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label
                                    htmlFor="expiration_date"
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                  >
                                    {t("due_date")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control"
                                        type="date"
                                        value={ownAssetsMgData.expiration_date}
                                        onChange={(e) => {
                                          setownAssetsMgData({
                                            ...ownAssetsMgData,
                                            expiration_date: e.target.value,
                                          });
                                        }}
                                        name="expiration_date"
                                        placeholder="Select Date"
                                      />
                                    </div>
                                    {errors.expiration_date && (
                                      <span className="input-error">
                                        {errors.expiration_date}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("customer_reference")}
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={ownAssetsMgData.customer_reference}
                                    onChange={(e) => {
                                      setownAssetsMgData({
                                        ...ownAssetsMgData,
                                        customer_reference: e.target.value,
                                      });
                                    }}
                                    name="customer_reference"
                                    placeholder="Customer Reference"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("globalDisc")}(%)
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={ownAssetsMgData.special_discount}
                                    onChange={(e) => {
                                      setownAssetsMgData({
                                        ...ownAssetsMgData,
                                        special_discount: e.target.value,
                                      });
                                    }}
                                    name="special_discount"
                                    placeholder="Global Disc"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("salesman")}
                                  </Label>
                                  <Select
                                    className="my-select-v"
                                    options={salesMenDataList}
                                    value={salesMenDataList.find(
                                      (item) =>
                                        item.value ===
                                        ownAssetsMgData.salesman_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setownAssetsMgData({
                                        ...ownAssetsMgData,
                                        salesman_id: selectedOption
                                          ? selectedOption.value
                                          : "",

                                        salesman_commission: selectedOption
                                          ? selectedOption?.base_commission
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Salesman"}
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("commission")}(%)
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="number"
                                    value={ownAssetsMgData.salesman_commission}
                                    onChange={(e) => {
                                      setownAssetsMgData({
                                        ...ownAssetsMgData,
                                        salesman_commission: e.target.value,
                                      });
                                    }}
                                    name="salesman_commission"
                                    placeholder="Commission"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("exchange_currency")}
                                  </Label>
                                  <Select
                                    className="my-select-v"
                                    options={exchangeCurrList}
                                    value={exchangeCurrList.find(
                                      (item) =>
                                        item.value ===
                                        ownAssetsMgData.exchange_currency_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setownAssetsMgData({
                                        ...ownAssetsMgData,
                                        exchange_currency_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Exchange Currency"}
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("exchange_rate")}
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="number"
                                    value={ownAssetsMgData.exchange_rate}
                                    onChange={(e) => {
                                      setownAssetsMgData({
                                        ...ownAssetsMgData,
                                        exchange_rate: e.target.value,
                                      });
                                    }}
                                    name="exchange_rate"
                                    placeholder="Exchange Rate"
                                  />
                                </FormGroup>
                              </div>
                              <div className="col-md-6" />
                            </div>
                          </div>
                        </div>

                        <div className="section-box">
                          <div
                            className={`section-header-green ${
                              openDelivery ? "active" : ""
                            }`}
                            onClick={() => setOpenDelivery(!openDelivery)}
                          >
                            <i
                              className={`bi ${
                                openDelivery
                                  ? "bi-chevron-up"
                                  : "bi-chevron-down"
                              }`}
                            ></i>
                            <span className="ms-2">
                              Delivery and Transportation
                            </span>
                          </div>

                          <div
                            className={`collapse ${openDelivery ? "show" : ""}`}
                          >
                            <div className="row mt-3">
                              <div className="col-md-6">
                                <p className="fw-semibold fs-5">Delivery</p>
                                <div
                                  class="alert alert-primary py-2"
                                  style={{ background: "#e8f4ff" }}
                                  for="actual_date_check"
                                >
                                  <div
                                    className="form-check"
                                    for="actual_date_check"
                                  >
                                    <input
                                      className="my-checkbox-1 form-check-input"
                                      type="checkbox"
                                      checked={
                                        ownAssetsMgData.actual_date_check === 1
                                      }
                                      onChange={(e) => {
                                        const checked = e.target.checked;

                                        setownAssetsMgData({
                                          ...ownAssetsMgData,
                                          actual_date_check: checked ? 1 : 0,
                                          delivery_datetime: checked
                                            ? getCurrentDateTime()
                                            : "",
                                        });
                                      }}
                                      id="actual_date_check"
                                    />
                                    <label
                                      class="form-check-label ms-2"
                                      for="actual_date_check"
                                      style={{ color: "black" }}
                                    >
                                      Fill with the actual date and time
                                    </label>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("startShipping")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="datetime-local"
                                          value={
                                            ownAssetsMgData.delivery_datetime ||
                                            ""
                                          }
                                          onChange={(e) => {
                                            setownAssetsMgData({
                                              ...ownAssetsMgData,
                                              delivery_datetime: e.target.value,
                                            });
                                          }}
                                          name="delivery_datetime"
                                          placeholder="Start Shipping"
                                        />
                                        {errors.delivery_datetime && (
                                          <span className="input-error">
                                            {errors.delivery_datetime}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("delivery")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={deliveryMethodList}
                                          value={deliveryMethodList.find(
                                            (item) =>
                                              item.value ===
                                              ownAssetsMgData.delivery_method_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setownAssetsMgData({
                                              ...ownAssetsMgData,
                                              delivery_method_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Delivery Method"}
                                        />
                                        {errors.delivery_method_id && (
                                          <span className="input-error">
                                            {errors.delivery_method_id}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("vehicle")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <Select
                                            className="my-select-v"
                                            options={vehiclesList}
                                            value={vehiclesList.find(
                                              (item) =>
                                                item.value ===
                                                ownAssetsMgData.vehicle_id,
                                            )}
                                            onChange={(selectedOption) => {
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                vehicle_id: selectedOption
                                                  ? selectedOption.value
                                                  : "",
                                              });
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder={"Select Vehicle"}
                                          />
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-6 d-flex align-items-end mb-4">
                                    <button
                                      type="button"
                                      className="btn btn-primary w-100"
                                      onClick={() =>
                                        setShowCreateVehicle(!showCreateVehicle)
                                      }
                                    >
                                      Create vehicle{" "}
                                      <i className="bi bi-plus"></i>
                                    </button>
                                  </div>
                                  {showCreateVehicle && (
                                    <>
                                      <div className="row">
                                        <div className="col-md-6">
                                          <Label
                                            htmlFor="vehicle_number_plate"
                                            className="col-form-label ml-2 Label-my form-label form-label"
                                          >
                                            {t("licensePlate")}
                                          </Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              ownAssetsMgData.vehicle_number_plate
                                            }
                                            onChange={(e) => {
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                vehicle_number_plate:
                                                  e.target.value,
                                              });
                                            }}
                                            name="vehicle_number_plate"
                                            placeholder="License Plate"
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <Label
                                            htmlFor="description"
                                            className="col-form-label ml-2 Label-my form-label form-label"
                                          >
                                            Description
                                          </Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={ownAssetsMgData.description}
                                            onChange={(e) => {
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                description: e.target.value,
                                              });
                                            }}
                                            name="description"
                                            placeholder="Description"
                                          />
                                        </div>
                                      </div>

                                      <div
                                        className="d-flex align-items-center gap-3 mb-3"
                                        style={{ marginLeft: "15px" }}
                                      >
                                        <div className="form-check mt-3">
                                          <input
                                            type="checkbox"
                                            id="saveMyVehicles"
                                            className="my-checkbox-1 form-check-input"
                                            checked={
                                              ownAssetsMgData.save_my_vehicle ===
                                              1
                                            }
                                            onChange={(e) => {
                                              const checked = e.target.checked;

                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                save_my_vehicle: checked
                                                  ? 1
                                                  : 0,
                                              });
                                            }}
                                          />
                                          <label
                                            htmlFor="saveMyVehicles"
                                            className="form-check-label ms-2"
                                          >
                                            Save on my vehicles
                                          </label>
                                        </div>

                                        <div className="form-check d-flex align-items-center gap-1">
                                          <div className="form-check mt-3">
                                            <input
                                              type="checkbox"
                                              id="preset"
                                              className="my-checkbox-1 form-check-input"
                                              checked={
                                                ownAssetsMgData.preset === 1
                                              }
                                              onChange={(e) => {
                                                const checked =
                                                  e.target.checked;

                                                setownAssetsMgData({
                                                  ...ownAssetsMgData,
                                                  preset: checked ? 1 : 0,
                                                });
                                              }}
                                            />
                                            <label
                                              htmlFor="presetCheck"
                                              className="form-check-label ms-2"
                                            >
                                              Preset
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>

                              <div className="col-md-6">
                                <p className="fw-semibold fs-5">Origin Place</p>

                                <div
                                  class="alert alert-primary py-2"
                                  style={{ background: "#e8f4ff" }}
                                  for="company_check"
                                >
                                  <div
                                    className="form-check"
                                    for="company_check"
                                  >
                                    <input
                                      className="my-checkbox-1 form-check-input"
                                      type="checkbox"
                                      checked={
                                        ownAssetsMgData.company_check === 1
                                      }
                                      onChange={(e) => {
                                        const checked = e.target.checked;

                                        setownAssetsMgData({
                                          ...ownAssetsMgData,
                                          company_check: checked ? 1 : 0,
                                        });
                                      }}
                                      id="company_check"
                                    />
                                    <label
                                      class="form-check-label ms-2"
                                      for="company_check"
                                      style={{ color: "black" }}
                                    >
                                      Fill with your company details
                                    </label>
                                  </div>
                                </div>

                                {ownAssetsMgData?.company_check === 1 && (
                                  <div className="col-md-12">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("defualt_address")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <Select
                                            className="my-select-v"
                                            options={alternateAddressList}
                                            value={alternateAddressList.find(
                                              (item) =>
                                                item.value ===
                                                ownAssetsMgData.alternate_address_id,
                                            )}
                                            onChange={(selectedOption) => {
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                alternate_address_id:
                                                  selectedOption
                                                    ? selectedOption.value
                                                    : "",
                                                delivery_departure_address:
                                                  selectedOption
                                                    ? selectedOption?.address
                                                    : "",
                                                delivery_departure_city:
                                                  selectedOption
                                                    ? selectedOption?.city
                                                    : "",
                                                delivery_departure_zip_code:
                                                  selectedOption
                                                    ? selectedOption?.zip_code
                                                    : "",
                                                delivery_departure_country:
                                                  selectedOption
                                                    ? selectedOption?.country_id
                                                    : "",
                                              });
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder={
                                              "Select Alternate Address"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>
                                )}

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("address")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <textarea
                                          className="form-control input-search"
                                          type="text"
                                          value={
                                            ownAssetsMgData.delivery_departure_address
                                          }
                                          onChange={(e) => {
                                            setownAssetsMgData({
                                              ...ownAssetsMgData,
                                              delivery_departure_address:
                                                e.target.value,
                                            });
                                          }}
                                          name="delivery_departure_address"
                                          placeholder="Address"
                                          rows={3}
                                        />
                                        {errors.delivery_departure_address && (
                                          <span className="input-error">
                                            {errors.delivery_departure_address}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="row">
                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("zipCode")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <input
                                            className="form-control input-search"
                                            type="text"
                                            value={
                                              ownAssetsMgData.delivery_departure_zip_code
                                            }
                                            onChange={(e) => {
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                delivery_departure_zip_code:
                                                  e.target.value,
                                              });
                                            }}
                                            name="delivery_departure_zip_code"
                                            placeholder="Zip Code"
                                          />
                                          {errors.delivery_departure_zip_code && (
                                            <span className="input-error">
                                              {
                                                errors.delivery_departure_zip_code
                                              }
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-8">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("city")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <input
                                            className="form-control input-search"
                                            type="text"
                                            value={
                                              ownAssetsMgData.delivery_departure_city
                                            }
                                            onChange={(e) => {
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                delivery_departure_city:
                                                  e.target.value,
                                              });
                                            }}
                                            name="delivery_departure_city"
                                            placeholder="city"
                                          />
                                          {errors.delivery_departure_city && (
                                            <span className="input-error">
                                              {errors.delivery_departure_city}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("country")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={countryList}
                                          value={countryList.find(
                                            (item) =>
                                              Number(item.value) ===
                                              Number(
                                                ownAssetsMgData.delivery_departure_country,
                                              ),
                                          )}
                                          onChange={(selectedOption) => {
                                            setownAssetsMgData({
                                              ...ownAssetsMgData,
                                              delivery_departure_country:
                                                selectedOption
                                                  ? selectedOption.value
                                                  : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Country"}
                                        />
                                        {errors.delivery_departure_country && (
                                          <span className="input-error">
                                            {errors.delivery_departure_country}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <p className="fw-semibold fs-5">
                                  Delivery Place
                                </p>

                                <div
                                  class="alert alert-primary py-2"
                                  style={{ background: "#e8f4ff" }}
                                  for="customer_check"
                                >
                                  <div
                                    className="form-check"
                                    for="customer_check"
                                  >
                                    <input
                                      className="my-checkbox-1 form-check-input"
                                      type="checkbox"
                                      checked={
                                        ownAssetsMgData.customer_check === 1
                                      }
                                      onChange={(e) => {
                                        const checked = e.target.checked;

                                        setownAssetsMgData({
                                          ...ownAssetsMgData,
                                          customer_check: checked ? 1 : 0,
                                        });
                                      }}
                                      id="customer_check"
                                    />
                                    <label
                                      class="form-check-label ms-2"
                                      for="customer_check"
                                      style={{ color: "black" }}
                                    >
                                      Fill with customer data
                                    </label>
                                  </div>
                                </div>

                                {ownAssetsMgData?.customer_check === 1 && (
                                  <div className="col-md-12">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("defualt_address")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <Select
                                            className="my-select-v"
                                            options={alternateAddressList}
                                            value={alternateAddressList.find(
                                              (item) =>
                                                item.value ===
                                                ownAssetsMgData.alternate_address_id,
                                            )}
                                            onChange={(selectedOption) => {
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                alternate_address_id:
                                                  selectedOption
                                                    ? selectedOption.value
                                                    : "",
                                                delivery_destination_address:
                                                  selectedOption
                                                    ? selectedOption?.address
                                                    : "",
                                                delivery_destination_city:
                                                  selectedOption
                                                    ? selectedOption?.city
                                                    : "",
                                                delivery_destination_zip_code:
                                                  selectedOption
                                                    ? selectedOption?.zip_code
                                                    : "",
                                                delivery_destination_country:
                                                  selectedOption
                                                    ? selectedOption?.country_id
                                                    : "",
                                              });
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder={
                                              "Select Alternate Address"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>
                                )}

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("address")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <textarea
                                          className="form-control input-search"
                                          type="text"
                                          value={
                                            ownAssetsMgData.delivery_destination_address
                                          }
                                          onChange={(e) => {
                                            setownAssetsMgData({
                                              ...ownAssetsMgData,
                                              delivery_destination_address:
                                                e.target.value,
                                            });
                                          }}
                                          name="delivery_destination_address"
                                          placeholder="Address"
                                          rows={3}
                                        />
                                        {errors.delivery_departure_country && (
                                          <span className="input-error">
                                            {errors.delivery_departure_country}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="row">
                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("zipCode")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <input
                                            className="form-control input-search"
                                            type="text"
                                            value={
                                              ownAssetsMgData.delivery_destination_zip_code
                                            }
                                            onChange={(e) => {
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                delivery_destination_zip_code:
                                                  e.target.value,
                                              });
                                            }}
                                            name="delivery_destination_zip_code"
                                            placeholder="Zip Code"
                                          />
                                          {errors.delivery_destination_zip_code && (
                                            <span className="input-error">
                                              {
                                                errors.delivery_destination_zip_code
                                              }
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-8">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("city")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <input
                                            className="form-control input-search"
                                            type="text"
                                            value={
                                              ownAssetsMgData.delivery_destination_city
                                            }
                                            onChange={(e) => {
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                delivery_destination_city:
                                                  e.target.value,
                                              });
                                            }}
                                            name="delivery_destination_city"
                                            placeholder="city"
                                          />
                                          {errors.delivery_destination_city && (
                                            <span className="input-error">
                                              {errors.delivery_destination_city}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("country")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={countryList}
                                          value={countryList.find(
                                            (item) =>
                                              Number(item.value) ===
                                              Number(
                                                ownAssetsMgData.delivery_destination_country,
                                              ),
                                          )}
                                          onChange={(selectedOption) => {
                                            setownAssetsMgData({
                                              ...ownAssetsMgData,
                                              delivery_destination_country:
                                                selectedOption
                                                  ? selectedOption.value
                                                  : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Country"}
                                        />
                                        {errors.delivery_destination_country && (
                                          <span className="input-error">
                                            {
                                              errors.delivery_destination_country
                                            }
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-12">
                                  <Button
                                    type="button"
                                    className="btn"
                                    onClick={handleShippingDelete}
                                    style={{
                                      color: "#ffffff",
                                      backgroundColor: "#dc3545",
                                      borderColor: "#dc3545",
                                      boxShadow: "none",
                                      padding: "6px 10px",
                                    }}
                                  >
                                    {t("deleteShippingInfo")}
                                  </Button>
                                </div>
                              </div>

                              <div className="col-md-6"></div>
                            </div>
                          </div>
                        </div>

                        <div className="section-box">
                          <div
                            className={`section-header-green ${
                              openNotes ? "active" : ""
                            }`}
                            onClick={() => setOpenNotes(!openNotes)}
                          >
                            <i
                              className={`bi ${
                                openNotes ? "bi-chevron-up" : "bi-chevron-down"
                              }`}
                            ></i>
                            <span className="ms-2">Notes</span>
                          </div>

                          <div
                            className={`collapse ${openNotes ? "show" : ""}`}
                          >
                            <div className="row mt-3">
                              <div className="col-md-12 mb-3">
                                <FormGroup>
                                  <Label className="Label-my">
                                    {t("notes")}
                                  </Label>
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={ownAssetsMgData.notes}
                                    onChange={(e) => {
                                      setownAssetsMgData({
                                        ...ownAssetsMgData,
                                        notes: e.target.value,
                                      });
                                    }}
                                    name="notes"
                                    placeholder="Notes"
                                    rows={4}
                                  />
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("products")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddProduct}
                              type="button"
                            >
                              + {t("add_product")}
                            </button>
                          </div>

                          {ownAssetsMgData?.products?.map((product, i) => (
                            <div key={i} className="card p-3 mb-3">
                              <h5>Product {i + 1}</h5>
                              <div className="row">
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("product")}
                                    </Label>
                                    <Select
                                      className="my-select-v"
                                      options={productList}
                                      value={productList.find(
                                        (item) =>
                                          item.value ===
                                          String(
                                            ownAssetsMgData.products[i]
                                              .product_id,
                                          ),
                                      )}
                                      onChange={(selectedOption) => {
                                        let list = [
                                          ...ownAssetsMgData.products,
                                        ];
                                        list[i].product_id = selectedOption
                                          ? selectedOption.value
                                          : null;
                                        setownAssetsMgData({
                                          ...ownAssetsMgData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i); // validation
                                        setSelectedProduct(selectedOption);
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Product"}
                                    />
                                    {errorsPro[i]?.product_id && (
                                      <small className="text-danger">
                                        {errorsPro[i].product_id}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("name")}
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Name"
                                      value={product.name}
                                      onChange={(e) => {
                                        let list = [
                                          ...ownAssetsMgData.products,
                                        ];
                                        list[i].name = e.target.value;
                                        setownAssetsMgData({
                                          ...ownAssetsMgData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i); //validation
                                      }}
                                    />
                                    {errorsPro[i]?.name && (
                                      <small className="text-danger">
                                        {errorsPro[i].name}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("summary")}
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Summary"
                                      value={product.summary}
                                      onChange={(e) => {
                                        let list = [
                                          ...ownAssetsMgData.products,
                                        ];
                                        list[i].summary = e.target.value;
                                        setownAssetsMgData({
                                          ...ownAssetsMgData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("quantity")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Quantity"
                                      value={product.qty}
                                      onChange={(e) => {
                                        let list = [
                                          ...ownAssetsMgData.products,
                                        ];
                                        list[i].qty = parseFloat(
                                          e.target.value,
                                        );
                                        setownAssetsMgData({
                                          ...ownAssetsMgData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i);
                                      }}
                                    />
                                    {errorsPro[i]?.qty && (
                                      <small className="text-danger">
                                        {errorsPro[i].qty}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("price")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Price"
                                      value={product.price}
                                      onChange={(e) => {
                                        let list = [
                                          ...ownAssetsMgData.products,
                                        ];
                                        list[i].price = parseFloat(
                                          e.target.value,
                                        );
                                        setownAssetsMgData({
                                          ...ownAssetsMgData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i);
                                      }}
                                    />
                                    {errorsPro[i]?.price && (
                                      <small className="text-danger">
                                        {errorsPro[i].price}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("discount")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Discount"
                                      value={product.discount}
                                      onChange={(e) => {
                                        let list = [
                                          ...ownAssetsMgData.products,
                                        ];
                                        list[i].discount = parseFloat(
                                          e.target.value,
                                        );
                                        setownAssetsMgData({
                                          ...ownAssetsMgData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("order")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Order"
                                      value={product.order}
                                      onChange={(e) => {
                                        let list = [
                                          ...ownAssetsMgData.products,
                                        ];
                                        list[i].order = parseFloat(
                                          e.target.value,
                                        );
                                        setownAssetsMgData({
                                          ...ownAssetsMgData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("exemption_reason")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={exemptionList}
                                          value={exemptionList.find(
                                            (item) =>
                                              item.value ===
                                              ownAssetsMgData.products[i]
                                                .exemption_reason,
                                          )}
                                          onChange={(selectedOption) => {
                                            let list = [
                                              ...ownAssetsMgData.products,
                                            ];
                                            list[i].exemption_reason =
                                              selectedOption
                                                ? selectedOption.value
                                                : null;
                                            setownAssetsMgData({
                                              ...ownAssetsMgData,
                                              products: list,
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={
                                            "Select Exemption Reason"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-3"></div>
                                <div className="col-md-3"></div>
                                <div className="col-md-3"></div>

                                <div className="row">
                                  <div
                                    className="col-md-12"
                                    style={{
                                      marginTop: "15px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    {" "}
                                    <h5>{t("tax")}</h5>
                                    <button
                                      className="btn btn-primary"
                                      onClick={(e) => handleAddTax(e, i)}
                                      type="button"
                                    >
                                      + {t("add_tax")}
                                    </button>
                                  </div>
                                  {product?.taxes?.length > 0 ? (
                                    <div
                                      className="row justify-content-start"
                                      style={{
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {product?.taxes?.map((prop, j) => (
                                        <div className="col-md-6">
                                          <div className="fileupload-content px-4">
                                            <div
                                              className="row justify-content-start align-items-center mb-2"
                                              key={j}
                                            >
                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("tax")}
                                                  </Label>
                                                  <Select
                                                    className="my-select-v"
                                                    options={taxDataList}
                                                    value={taxDataList.find(
                                                      (item) =>
                                                        item.value ===
                                                        String(
                                                          ownAssetsMgData
                                                            .products[i].taxes[
                                                            j
                                                          ].tax_id,
                                                        ),
                                                    )}
                                                    onChange={(
                                                      selectedOption,
                                                    ) => {
                                                      let list = [
                                                        ...ownAssetsMgData.products,
                                                      ];
                                                      list[i].taxes[j].tax_id =
                                                        selectedOption
                                                          ? selectedOption.value
                                                          : null;
                                                      setownAssetsMgData({
                                                        ...ownAssetsMgData,
                                                        products: list,
                                                      });
                                                    }}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder={"Select Tax"}
                                                  />
                                                </FormGroup>
                                              </div>

                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("value")}
                                                  </Label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Value"
                                                    value={prop.value}
                                                    onChange={(e) => {
                                                      let list = [
                                                        ...ownAssetsMgData.products,
                                                      ];
                                                      list[i].taxes[j].value =
                                                        e.target.value;
                                                      setownAssetsMgData({
                                                        ...ownAssetsMgData,
                                                        products: list,
                                                      });
                                                    }}
                                                  />
                                                </FormGroup>
                                              </div>
                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("order")}
                                                  </Label>
                                                  <input
                                                    type="Number"
                                                    className="form-control"
                                                    placeholder="Order"
                                                    value={prop.order}
                                                    onChange={(e) => {
                                                      let list = [
                                                        ...ownAssetsMgData.products,
                                                      ];
                                                      list[i].taxes[j].order =
                                                        e.target.value;
                                                      setownAssetsMgData({
                                                        ...ownAssetsMgData,
                                                        products: list,
                                                      });
                                                    }}
                                                  />
                                                </FormGroup>
                                              </div>

                                              <div className="col-md-4 d-flex align-item-center">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("cumulative")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          className="my-checkbox-1 form-check-input"
                                                          type="checkbox"
                                                          checked={
                                                            prop.cumulative ===
                                                            1
                                                          }
                                                          onChange={(e) => {
                                                            let list = [
                                                              ...ownAssetsMgData.products,
                                                            ];
                                                            list[i].taxes[
                                                              j
                                                            ].cumulative = e
                                                              .target.checked
                                                              ? 1
                                                              : 0;
                                                            setownAssetsMgData({
                                                              ...ownAssetsMgData,
                                                              products: list,
                                                            });
                                                          }}
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("Cumulative")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>

                                              <div className="d-flex align-item-center">
                                                <button
                                                  className="btn btn-danger"
                                                  onClick={(e) =>
                                                    handleRemoveTax(e, i, j)
                                                  }
                                                >
                                                  <i className="bi bi-trash"></i>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <p className="text-muted">
                                      No tax list added.
                                    </p>
                                  )}
                                </div>
                              </div>

                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={(e) => handleRemoveProduct(e, i)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>

                              <div className="row d-none">
                                <div
                                  className="col-md-12"
                                  style={{
                                    marginTop: "15px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <h5>{t("child_products")}</h5>
                                  <button
                                    className="btn btn-primary"
                                    onClick={(e) => handleAddChildProduct(e, i)}
                                    type="button"
                                  >
                                    + {t("add_child_product")}
                                  </button>
                                </div>

                                {product?.child_products?.map((child, k) => (
                                  <div key={k} className="card p-2 mb-2 border">
                                    <h6>Child Product {k + 1}</h6>

                                    <div className="row">
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("child_name")}</Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={child.name}
                                            onChange={(e) => {
                                              let list = [
                                                ...ownAssetsMgData.products,
                                              ];
                                              list[i].child_products[k].name =
                                                e.target.value;
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("summary")}</Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={child.summary}
                                            onChange={(e) => {
                                              let list = [
                                                ...ownAssetsMgData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].summary = e.target.value;
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("quantity")}</Label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={child.qty}
                                            onChange={(e) => {
                                              let list = [
                                                ...ownAssetsMgData.products,
                                              ];
                                              list[i].child_products[k].qty =
                                                parseFloat(e.target.value);
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("price")}</Label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={child.price}
                                            onChange={(e) => {
                                              let list = [
                                                ...ownAssetsMgData.products,
                                              ];
                                              list[i].child_products[k].price =
                                                parseFloat(e.target.value);
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                    </div>

                                    {/* Properties Section for child */}
                                    <div className="row mt-2">
                                      <h6>{t("properties")}</h6>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={(e) =>
                                          handleAddChildProperty(e, i, k)
                                        }
                                        type="button"
                                      >
                                        + {t("add_property")}
                                      </button>
                                      {child?.properties?.map((prop, j) => (
                                        <div
                                          key={j}
                                          className="d-flex gap-2 mb-2"
                                        >
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Title"
                                            value={prop.title}
                                            onChange={(e) => {
                                              let list = [
                                                ...ownAssetsMgData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].properties[j].title =
                                                e.target.value;
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Value"
                                            value={prop.value}
                                            onChange={(e) => {
                                              let list = [
                                                ...ownAssetsMgData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].properties[j].value =
                                                e.target.value;
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>

                                    {/* Taxes Section for child */}
                                    <div className="row mt-2">
                                      <h6>{t("taxes")}</h6>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={(e) =>
                                          handleAddChildTax(e, i, k)
                                        }
                                        type="button"
                                      >
                                        + {t("add_tax")}
                                      </button>
                                      {child?.taxes?.map((tax, j) => (
                                        <div
                                          key={j}
                                          className="d-flex gap-2 mb-2"
                                        >
                                          <Select
                                            className="my-select-v"
                                            options={taxDataList}
                                            value={taxDataList.find(
                                              (item) =>
                                                item.value === tax.tax_id,
                                            )}
                                            onChange={(selectedOption) => {
                                              let list = [
                                                ...ownAssetsMgData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].tax_id = selectedOption
                                                ? selectedOption.value
                                                : null;
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                products: list,
                                              });
                                            }}
                                            isSearchable
                                            isClearable
                                            placeholder="Select Tax"
                                          />
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Value"
                                            value={tax.value}
                                            onChange={(e) => {
                                              let list = [
                                                ...ownAssetsMgData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].value = parseFloat(
                                                e.target.value,
                                              );
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Order"
                                            value={tax.order}
                                            onChange={(e) => {
                                              let list = [
                                                ...ownAssetsMgData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].order = parseFloat(
                                                e.target.value,
                                              );
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="checkbox"
                                            checked={tax.cumulative === 1}
                                            onChange={(e) => {
                                              let list = [
                                                ...ownAssetsMgData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].cumulative = e.target.checked
                                                ? 1
                                                : 0;
                                              setownAssetsMgData({
                                                ...ownAssetsMgData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>

                                    {/* Remove child button */}
                                    <button
                                      className="btn btn-danger mt-2"
                                      onClick={(e) =>
                                        handleRemoveChildProduct(e, i, k)
                                      }
                                    >
                                      <i className="bi bi-trash"></i>{" "}
                                      {t("remove_child_product")}
                                    </button>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row">
                          <div className="col ms-2">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => navigate("/ownAssetsMovement")}
                            >
                              <i className="bi bi-arrow-left"> </i> {t("back")}
                            </button>
                          </div>
                          <div className="col">
                            <div className="d-flex justify-content-end nxt-btn">
                              {btnLoader === true ? (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Loading...
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  {t("submit")} <i className="bi bi-check2"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>

            <Modal isOpen={customerModel} size="xl">
              <ModalHeader>{t("CreateCustomer")}</ModalHeader>
              <Form method={`post`}>
                <ModalBody>
                  <div className="row">
                    <div className="mb-3">
                      {/* Tabs */}
                      <ul className="custom-tabs">
                        <li
                          className={
                            activeCustomerTab === "1"
                              ? "tab-item active"
                              : "tab-item"
                          }
                          onClick={() => setActiveCustomerTab("1")}
                        >
                          {t("main")}
                        </li>

                        <li
                          className={
                            activeCustomerTab === "2"
                              ? "tab-item active"
                              : "tab-item"
                          }
                          onClick={() => setActiveCustomerTab("2")}
                        >
                          {t("contact")}
                        </li>

                        <li
                          className={
                            activeCustomerTab === "3"
                              ? "tab-item active"
                              : "tab-item"
                          }
                          onClick={() => setActiveCustomerTab("3")}
                        >
                          {t("otherAddresses")}
                        </li>

                        <li
                          className={
                            activeCustomerTab === "4"
                              ? "tab-item active"
                              : "tab-item"
                          }
                          onClick={() => setActiveCustomerTab("4")}
                        >
                          {t("billingSettings")}
                        </li>
                      </ul>

                      <div className="tab-content-area">
                        {activeCustomerTab === "1" && (
                          <div className="row">
                            <div class="alert alert-light" role="alert">
                              NOTE: All required fields are marked with{" "}
                              <span style={{ color: "red" }}>(*)</span>
                            </div>

                            <p>General Information</p>
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("vat")}{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.vat}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        vat: e.target.value,
                                      });
                                    }}
                                    name={`vat`}
                                    maxLength={50}
                                    placeholder="Vat"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("number")}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.number}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        number: e.target.value,
                                      });
                                    }}
                                    name={`number`}
                                    maxLength={50}
                                    placeholder="Number"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("Name")}{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.name}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        name: e.target.value,
                                      });
                                    }}
                                    name={`name`}
                                    maxLength={50}
                                    placeholder="Name"
                                  />
                                </div>
                                {errors.name && (
                                  <span className="input-error">
                                    {errors.name}
                                  </span>
                                )}
                              </FormGroup>
                            </div>
                            <div class="alert alert-primary" role="alert">
                              Fill with default data
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("address")}
                                </Label>
                                <span className="text-danger">*</span>

                                <div className="col-xl-12">
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.address}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        address: e.target.value,
                                      });
                                    }}
                                    name={`address`}
                                    maxLength={50}
                                    placeholder="Address"
                                    rows={3}
                                  />
                                </div>
                              </FormGroup>
                            </div>
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("city")}
                                </Label>
                                <span className="text-danger">*</span>

                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.city}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        city: e.target.value,
                                      });
                                    }}
                                    name={`city`}
                                    maxLength={50}
                                    placeholder="City"
                                  />
                                </div>
                              </FormGroup>
                            </div>
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("zip_code")}
                                </Label>
                                <span className="text-danger">*</span>

                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.zip_code}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        zip_code: e.target.value,
                                      });
                                    }}
                                    name={`zip_code`}
                                    maxLength={50}
                                    placeholder="Zip code"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("country")}
                                </Label>
                                <span className="text-danger">*</span>

                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={countryList}
                                      value={countryList.find(
                                        (item) =>
                                          item.value == customerData.country_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          country_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Country"}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("email")}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.email}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        email: e.target.value,
                                      });
                                    }}
                                    name={`email`}
                                    maxLength={50}
                                    placeholder="Contact email"
                                  />
                                  {errors.email && (
                                    <span className="input-error">
                                      {errors.email}
                                    </span>
                                  )}
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4" />
                          </div>
                        )}

                        {activeCustomerTab === "2" && (
                          <div className="row">
                            <div class="alert alert-light" role="alert">
                              NOTE: All required fields are marked with{" "}
                              <span style={{ color: "red" }}>(*)</span>
                            </div>

                            <p>Contacts</p>
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("phone")}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={customerData.phone}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        phone: e.target.value,
                                      });
                                    }}
                                    name={`phone`}
                                    placeholder="Phone"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("fax")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={customerData.fax}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        fax: e.target.value,
                                      });
                                    }}
                                    name={`fax`}
                                    placeholder="Fax"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("website")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.website}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        website: e.target.value,
                                      });
                                    }}
                                    name={`website`}
                                    placeholder="website"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("contactPerson")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.contact_person}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        contact_person: e.target.value,
                                      });
                                    }}
                                    name={`contact_person`}
                                    placeholder="Contact Person"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("contactEmail")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.contact_email}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        contact_email: e.target.value,
                                      });
                                    }}
                                    name={`contact_email`}
                                    placeholder="Contact Email"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("telephoneContact")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.telephone_contact}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        telephone_contact: e.target.value,
                                      });
                                    }}
                                    name={`telephone_contact`}
                                    placeholder="Telephone Contact"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-12">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("contactNotes")}
                                </Label>
                                <div className="col-xl-12">
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.contact_notes}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        contact_notes: e.target.value,
                                      });
                                    }}
                                    name={`contact_notes`}
                                    placeholder="Contact Notes"
                                    rows={4}
                                  />
                                </div>
                              </FormGroup>
                            </div>
                          </div>
                        )}

                        {activeCustomerTab === "3" && (
                          <>
                            <div className="row">
                              <div className="alert alert-light" role="alert">
                                NOTE: All required fields are marked with{" "}
                                <span style={{ color: "red" }}>(*)</span>
                              </div>

                              <p>Alternate Address</p>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Description
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="description"
                                    value={altForm.description}
                                    onChange={handleAltChange}
                                    placeholder="Description"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Code
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="code"
                                    value={altForm.code}
                                    onChange={handleAltChange}
                                    placeholder="Code"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Zip Code
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="zip_code"
                                    value={altForm.zip_code}
                                    onChange={handleAltChange}
                                    placeholder="Zip Code"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    City
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="city"
                                    value={altForm.city}
                                    onChange={handleAltChange}
                                    placeholder="City"
                                  />
                                </FormGroup>
                              </div>

                              {/* Country */}
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Country
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <Select
                                    className="my-select-v"
                                    options={countryList}
                                    value={
                                      countryList.find(
                                        (item) =>
                                          item.value === altForm.country,
                                      ) || null
                                    }
                                    onChange={(selectedOption) => {
                                      setAltForm({
                                        ...altForm,
                                        country: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder="Select Country"
                                  />
                                </FormGroup>
                              </div>

                              {/* Email */}
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    E-mail
                                  </Label>
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="email"
                                    value={altForm.email}
                                    onChange={handleAltChange}
                                    placeholder="Email"
                                  />
                                </FormGroup>
                              </div>

                              {/* Phone */}
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Phone
                                  </Label>
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="phone"
                                    value={altForm.phone}
                                    onChange={handleAltChange}
                                    placeholder="Phone"
                                  />
                                </FormGroup>
                              </div>

                              {/* Fax */}
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Fax
                                  </Label>
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="fax"
                                    value={altForm.fax}
                                    onChange={handleAltChange}
                                    placeholder="Fax"
                                  />
                                </FormGroup>
                              </div>

                              {/* Contact Person */}
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Contact Person
                                  </Label>
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="contact_person"
                                    value={altForm.contact_person}
                                    onChange={handleAltChange}
                                    placeholder="Contact Person"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-12">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Address
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <textarea
                                    className="form-control input-search"
                                    rows={4}
                                    name="address"
                                    value={altForm.address}
                                    onChange={handleAltChange}
                                    placeholder="Address"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-12 mt-3">
                                <button
                                  className="btn btn-primary"
                                  onClick={saveAlternateAddress}
                                  type="button"
                                >
                                  {editIndex !== null
                                    ? "Update Address"
                                    : "Add Address"}
                                </button>
                              </div>
                            </div>

                            <div>
                              {ownAssetsMgData?.alternate_address?.length >
                                0 && (
                                <table className="table table-bordered mt-4">
                                  <thead>
                                    <tr>
                                      <th>Code</th>
                                      <th>City</th>
                                      <th>Country</th>
                                      <th>Email</th>
                                      <th style={{ width: "120px" }}>
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {ownAssetsMgData?.alternate_address?.map(
                                      (item, index) => (
                                        <tr key={index}>
                                          <td>{item.code}</td>
                                          <td>{item.city}</td>
                                          <td>{item.country}</td>
                                          <td>{item.email}</td>
                                          <td>
                                            <div className="d-flex gap-2">
                                              <button
                                                className="btn btn-sm"
                                                type="button"
                                                onClick={() =>
                                                  editAlternateAddress(index)
                                                }
                                              >
                                                <i className="bi bi-pencil"></i>
                                              </button>

                                              <button
                                                className="btn btn-sm"
                                                type="button"
                                                onClick={() =>
                                                  deleteAlternateAddress(index)
                                                }
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </>
                        )}

                        {activeCustomerTab === "4" && (
                          <div className="row">
                            <div className="alert alert-light" role="alert">
                              NOTE: All required fields are marked with{" "}
                              <span style={{ color: "red" }}>(*)</span>
                            </div>

                            <p>Billing Settings</p>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("language")}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={languageList}
                                      value={languageList.find(
                                        (item) =>
                                          item.value ==
                                          customerData.language_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          language_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Language"}
                                    />
                                    {errors.language_id && (
                                      <span className="input-error">
                                        {errors.language_id}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("PriceTablesByDefault")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={priceClassList}
                                      value={priceClassList.find(
                                        (item) =>
                                          item.value ==
                                          customerData.price_class_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          price_class_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={
                                        "Select Price Tables By Default"
                                      }
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("Maturity")}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={maturityDatesList}
                                      value={maturityDatesList.find(
                                        (item) =>
                                          item.value ==
                                          customerData.maturity_date_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          maturity_date_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Maturity"}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("payment_day")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search"
                                      type="number"
                                      value={customerData.payment_day}
                                      onChange={(e) => {
                                        setCustomerData({
                                          ...customerData,
                                          payment_day: e.target.value,
                                        });
                                      }}
                                      name={`payment_day`}
                                      maxLength={50}
                                      placeholder="Payment day"
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("globalDiscount")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search"
                                      type="number"
                                      value={customerData.global_discount_id}
                                      onChange={(e) => {
                                        setCustomerData({
                                          ...customerData,
                                          global_discount_id: e.target.value,
                                        });
                                      }}
                                      name={`global_discount_id`}
                                      maxLength={50}
                                      placeholder="Global Discount"
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("credit_limit")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search"
                                      type="number"
                                      value={customerData.credit_limit}
                                      onChange={(e) => {
                                        setCustomerData({
                                          ...customerData,
                                          credit_limit: e.target.value,
                                        });
                                      }}
                                      name={`credit_limit`}
                                      maxLength={50}
                                      placeholder="Credit limit"
                                    />
                                    {errors.credit_limit && (
                                      <span className="input-error">
                                        {errors.credit_limit}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("paymentMethod")}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={paymentMethodList}
                                      value={paymentMethodList.find(
                                        (item) =>
                                          item.value ==
                                          customerData.payment_method_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          payment_method_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Payment Method"}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("deliveryMethod")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={deliveryMethodList}
                                      value={deliveryMethodList.find(
                                        (item) =>
                                          item.value ==
                                          customerData.delivery_method_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          delivery_method_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Payment Method"}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("salesmen")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={salesmenList}
                                      value={salesmenList.find(
                                        (item) =>
                                          item.value ===
                                          customerData.salesman_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          salesman_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Salesmen"}
                                    />
                                    {errors.salesman_id && (
                                      <span className="input-error">
                                        {errors.salesman_id}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("notes")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search"
                                      type="text"
                                      value={customerData.notes}
                                      onChange={(e) => {
                                        setCustomerData({
                                          ...customerData,
                                          notes: e.target.value,
                                        });
                                      }}
                                      name={`notes`}
                                      maxLength={50}
                                      placeholder="notes"
                                    />
                                  </div>
                                  {errors.notes && (
                                    <span className="input-error">
                                      {errors.notes}
                                    </span>
                                  )}
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4" />
                            <div className="col-md-4" />
                            <div className="col-md-4" />
                            <div className="col-md-4" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <button
                    type="button"
                    className="btn btn-block btn-primary"
                    disabled={isModifyButtonLoad}
                    onClick={handleCustomerCloseModel}
                    style={{ width: "100px", marginTop: "10px" }}
                  >
                    {t("close")} <i className="bi bi-x-lg"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: "120px" }}
                    disabled={isModifyButtonLoad}
                    onClick={handleCustomerSubmit}
                  >
                    {isModifyButtonLoad ? (
                      <>
                        <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                        Loading...
                      </>
                    ) : (
                      <>
                        {t("submit")} <i className="bi bi-check2"></i>
                      </>
                    )}
                  </button>
                </ModalFooter>
              </Form>
            </Modal>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddOwnAssetsMovement;
